export enum Storage {
  acceptedUseTerms = '@PE_acceptedUseTerms',
}
